import React, { useState } from 'react';
import axios from 'axios';

/**
 * SimpleUploadPage - Bare-bones upload with NO fancy components
 * Just HTML elements and axios - nothing that can break
 */
export default function SimpleUploadPage() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError(null);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file');
      return;
    }

    setUploading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const isCSV = file.name.toLowerCase().endsWith('.csv');
      const endpoint = isCSV ? '/api/analyze/upload' : '/api/analyze/ocr';

      const response = await axios.post(`${endpoint}?category=Driver&club_type=Driver&dexterity=RH&mode=matrix&playing_conditions=false`, formData);

      console.log('Upload response:', response.data);
      setResult(response.data);
      setFile(null);
    } catch (err) {
      console.error('Upload error:', err);
      setError(err.response?.data?.detail || err.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const reset = () => {
    setFile(null);
    setResult(null);
    setError(null);
  };

  if (result) {
    return (
      <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        <button onClick={reset} style={{ marginBottom: '20px', padding: '10px 20px' }}>
          ← Upload Another
        </button>

        <h2>Upload Successful!</h2>

        {result.aggregated && (
          <div style={{ background: '#1a1a1a', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
            <h3>Session Average</h3>
            <p>Ball Speed: {result.aggregated.ball_speed} mph</p>
            <p>Launch Angle: {result.aggregated.launch_angle}°</p>
            <p>Spin Rate: {result.aggregated.spin_rate} rpm</p>
            <p>Carry: {result.aggregated.carry_distance} yards</p>
          </div>
        )}

        {result.matrix && (
          <div style={{ marginTop: '20px' }}>
            <h3>Matrix Generated</h3>
            <p>Recommendations count: {result.matrix.recommendations?.length || 0}</p>
          </div>
        )}

        <details style={{ marginTop: '20px' }}>
          <summary style={{ cursor: 'pointer', padding: '10px', background: '#2a2a2a' }}>
            View Raw JSON
          </summary>
          <pre style={{ background: '#0a0a0a', padding: '10px', overflow: 'auto', maxHeight: '400px' }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </details>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Simple Upload Test</h1>
      <p style={{ color: '#888' }}>Upload CSV or launch monitor image</p>

      <div style={{ marginTop: '30px' }}>
        <input
          type="file"
          accept=".csv,image/*"
          onChange={handleFileChange}
          disabled={uploading}
          style={{ display: 'block', marginBottom: '20px', padding: '10px' }}
        />

        {file && (
          <p style={{ color: '#4ade80' }}>
            Selected: {file.name} ({(file.size / 1024).toFixed(1)} KB)
          </p>
        )}

        <button
          onClick={handleUpload}
          disabled={!file || uploading}
          style={{
            padding: '12px 24px',
            background: uploading ? '#555' : '#2563eb',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: uploading ? 'not-allowed' : 'pointer',
            fontSize: '16px',
            marginTop: '10px'
          }}
        >
          {uploading ? 'Uploading...' : 'Upload & Analyze'}
        </button>

        {error && (
          <div style={{ marginTop: '20px', padding: '15px', background: '#7f1d1d', borderRadius: '6px', color: '#fca5a5' }}>
            <strong>Error:</strong> {error}
          </div>
        )}
      </div>

      <div style={{ marginTop: '40px', padding: '15px', background: '#1e293b', borderRadius: '6px' }}>
        <h4 style={{ marginTop: 0 }}>Test Instructions:</h4>
        <ol style={{ fontSize: '14px', lineHeight: '1.6' }}>
          <li>Select a CSV file or launch monitor image</li>
          <li>Click "Upload & Analyze"</li>
          <li>If it works, you'll see results</li>
          <li>If it crashes, check console for error</li>
        </ol>
      </div>
    </div>
  );
}
